var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "collapsed-text align-lidarText" }, [
      _vm._v("2D LIDAR"),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        attrs: { id: "lidarPanelToggle" },
        on: {
          click: function ($event) {
            return _vm.toggleLidar()
          },
        },
      },
      [
        _c("fa", {
          class: `collapsed-symbol ${_vm.faIconClass}`,
          attrs: { icon: ["fas", _vm.faIcon], size: "3x" },
        }),
        _vm._v(" "),
        _vm.faIcon == "exclamation-triangle"
          ? _c("p", { staticClass: "no-drag lidar-warning clickable" }, [
              _vm._v("\n      ZOOM IN\n    "),
            ])
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }